import React, { useEffect } from 'react';

const MockInterviewScheduler = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: MockInterviewScheduler is not implemented yet.');
  }, []);
  return (
    <>
  { /*MockInterviewScheduler */} 
 </>
  );
};

export default MockInterviewScheduler;
